import { centerable as n } from "../decorators/centerable.js";
import { stylable as s } from "../decorators/stylable.js";
import { ALIGN_CLASSES_INVERSE as a } from "../../constants.js";
import { defineAttrs as o } from "../../utils/typed-attrs.js";
const m = o({
  type: { default: "small" }
}), A = s(
  n({
    inline: !1,
    content: "inline*",
    group: "block",
    attrs: m,
    parseDOM: [
      {
        tag: "small",
        getAttrs(t) {
          let e;
          return t.parentElement && t.parentElement.classList.forEach((r) => {
            const l = a[r];
            l && (e = l);
          }), {
            alignment: e
          };
        }
      }
    ],
    toDOM() {
      return ["small", 0];
    }
  })
);
export {
  A as smallSpec
};
